/**
 * Labstep
 *
 * @module containers/User/Logout
 * @desc Logout container
 */

import type { APICallOptions } from 'labstep-web/models';
import { logoutAction } from 'labstep-web/state/actions/user';
import { connect } from 'react-redux';

export type UserLogoutChildrenProps = ReturnType<
  typeof mapDispatchToProps
>;

const LogoutContainer = ({
  children,
  ...rest
}: {
  children: (
    props: UserLogoutChildrenProps,
  ) => React.ReactElement | null;
} & UserLogoutChildrenProps) => children(rest);

const mapDispatchToProps = (dispatch: (...args: any[]) => void) => ({
  logout: (options?: APICallOptions) => {
    dispatch(logoutAction(options));
  },
  logoutWithoutApi: () => {
    dispatch({ type: 'LOGOUT_SUCCESS' });
  },
});

export const UserLogoutContainer = connect(
  () => ({}),
  mapDispatchToProps,
)(LogoutContainer);
